import { useContext } from "react";
import { AppContext, IAppContextType } from "./App.context";

export const useAppContext = (): IAppContextType => {
	return useContext(AppContext);
};
